import { ADVISOR_AGREEMENT_FRAGMENT } from '@src/gql/fragments/AdvisorAgreementFragment'
import { gql } from '@src/lib/gql'

export const ADVISOR_AGREEMENT = gql`
  query AdvisorAgreement($advisorAgreementId: String) {
    advisorAgreement(advisorAgreementId: $advisorAgreementId) {
      ...AdvisorAgreementFragment
    }
  }
  ${ADVISOR_AGREEMENT_FRAGMENT}
`
